<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">
                <app-card :title="$t('Reset password')">
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="reset(validate)">
                            <div class="alert alert-success" role="alert" v-if="status">
                                {{ status }}
                            </div>

                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email" inline>
                                <template #label>
                                    {{ $t('Email') }}
                                </template>
                            </app-input>

                            <app-input id="password" v-model="form.password" name="password" rules="required|password:@password_confirmation" type="password" inline>
                                <template #label>
                                    {{ $t('Password') }}
                                </template>
                            </app-input>

                            <app-input id="password_confirmation" v-model="form.password_confirmation" rules="required" name="password_confirmation" type="password" inline>
                                <template #label>
                                    {{ $t('Confirm password') }}
                                </template>
                            </app-input>

                            <app-button :loading="loading" small>
                                {{ $t('reset_password') }}
                            </app-button>
                        </form>
                    </validation-observer>
                </app-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            status: '',
            loading: false,
            form: {
                token: '',
                email: '',
                password: '',
                password_confirmation: ''
            }
        };
    },
    methods: {
        reset(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post('/password/reset', this.form).then(res => {
                        this.status = res.data.status;
                        this.$store.dispatch('LOGIN', this.form).then(() => {
                            this.loading = false;
                        });
                    });
                }
            });
        }
    },
    created() {
        this.form.email = this.$route.query.email;
        this.form.token = this.$route.params.token;
    }
};
</script>
